import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';
import moment from 'moment';

import StoreS3 from '../../util/StoreS3.jsx';
import Common from '../../util/Common.jsx';
import DeleteConfirm from '../../util/DeleteConfirm.jsx';
import WorksetItemDetail from "./WorksetItemDetail.jsx"
import {GenericButton, SmallGenericButton, IndentedContentWrapper} from '../../util/Styles.jsx';
import Utils from "../../../common/Utils.jsx";

const WorksetItemName = styled.div`
    display: inline-block;
    margin-right: 0.25rem;
    font-family: Courier;
    font-size: 1rem;
    font-weight: bold;
    background-color: #667788;
    color: white;
    padding: 0.05rem 0.25rem;
    border-radius: 0.15rem;
    border: 0.1rem solid grey;
    vertical-align: top;
    cursor: pointer;
`;

const WorksetItemInput = styled.input`
    display: inline-block;
    font-family: Courier;
    font-size: 1.1rem;
    font-weight: bold;
    background-color: #667788;
    color: white;
    padding: 0.1rem 0.25rem;
    border-radius: 0.25rem;
    border: 0.1rem solid grey;
`;

const WorksetItemDescription = styled.div`
    display: inline-block;
    margin-left: 0.5rem;
    font-style: italic;
    color: #aaaaaa;
    font-size: 1rem;
    vertical-align: bottom;
`;

export class WorksetItem extends Component {

    static propTypes = {
        workset_item: PropTypes.object.isRequired
    }

    state = {
        expanded: false,
        in_title_edit: false,
        in_delete_confirm: false,
        workset_item: this.props.workset_item,
        workset_item_title: this.props.workset_item.title,
        revert_workset_item_title: ''
    };

    componentDidMount() {
        const {workset_item} = this.state;
        const expanded = localStorage.getItem(workset_item.slug, 0)
        this.setState({expanded: expanded})
    }

    async put_workset_item(workset_item) {
        workset_item["updated"] = moment().format();
        const workset_item_json = JSON.stringify(workset_item, undefined, 2);
        await StoreS3.put_file(workset_item.path, workset_item_json);
        this.setState({
            workset_item: workset_item,
            workset_item_title: workset_item.title
        });
    }

    async delete_workset_item(workset_item_key) {
        await StoreS3.delete_file(workset_item_key);
    }

    edit_workset() {
        const {expanded, workset_item} = this.state;
        if (!expanded) {
            localStorage.setItem(workset_item.slug, 1)
        } else {
            localStorage.removeItem(workset_item.slug)
        }
        this.setState({expanded: !expanded})
    }

    hover_edit(e, is_over) {
        e.target.style.opacity = is_over ? 1 : 0;
    }

    edit_workset_item_title() {
        this.setState({
            in_title_edit: true,
            revert_workset_item_title: this.state.workset_item_title,
        })
    }

    change_title_text(e) {
        this.setState({workset_item_title: e.target.value})
    }

    change_workset_item_title() {
        const workset_item = this.state.workset_item;
        workset_item.title = this.state.workset_item_title;
        workset_item.slug = Common.slugify(this.state.workset_item_title);

        this.delete_workset_item(workset_item.path);

        const last_slash = workset_item.path.lastIndexOf('/');
        workset_item.path = workset_item.path.slice(0, last_slash + 1) + workset_item.slug + ".json"

        this.put_workset_item(workset_item);
        this.setState({in_title_edit: false})
    }

    cancel_edit_workset_item_title() {
        this.setState({
            in_title_edit: false,
            workset_item_title: this.state.revert_workset_item_title
        })
    }

    delete_work_item() {
        this.setState({in_delete_confirm: true})
    }

    async confirm_delete_item() {
        await StoreS3.delete_file(this.props.workset_item.path);
        this.setState({in_delete_confirm: false})
    }

    cancel_delete_item() {
        this.setState({in_delete_confirm: false})
    }

    async publish_work_item() {
        const {workset_item} = this.state;
        const path = workset_item.path;

        const last_slash = path.lastIndexOf('/');
        const branch = await StoreS3.get_file_tree(path.slice(0, last_slash + 1))

        Utils.download_json(branch[workset_item.title], workset_item.slug);
    }

    render() {
        const {
            workset_item,
            in_title_edit,
            in_delete_confirm,
            expanded,
            workset_item_title} = this.state;
        if (!workset_item.title) {
            return '';
        }
        const edit_link = in_title_edit || in_delete_confirm || !expanded ? '' :
            <SmallGenericButton
                onMouseOver={e => this.hover_edit(e, true)}
                onMouseOut={e => this.hover_edit(e, false)}
                onClick={e => this.edit_workset_item_title(e)}>
                edit
            </SmallGenericButton>
        const ok_button = in_title_edit ?
            <GenericButton onClick={e => this.change_workset_item_title(e)}>ok</GenericButton> : '';
        const cancel_button = in_title_edit ?
            <GenericButton onClick={e => this.cancel_edit_workset_item_title()}>cancel</GenericButton> : '';

        const workset_item_detail = expanded ?
            <WorksetItemDetail workset_item={workset_item}/> : '';

        const workset_item_title_input = in_title_edit ?
            <WorksetItemInput
                type={"text"}
                value={workset_item_title}
                onChange={e => this.change_title_text(e)}/> :
            <WorksetItemName onClick={e => this.edit_workset()} title={this.props.workset_item.path}>
                {workset_item_title}
            </WorksetItemName>;

        const workset_item_value = expanded ? '' :
            <WorksetItemDescription>{workset_item.value}</WorksetItemDescription>;

        const delete_item = in_title_edit || in_delete_confirm || !expanded ? '' :
            <SmallGenericButton
                onMouseOver={e => this.hover_edit(e, true)}
                onMouseOut={e => this.hover_edit(e, false)}
                onClick={e => this.delete_work_item()}>
                delete...
            </SmallGenericButton>;
        const delete_confirm = !in_delete_confirm || in_title_edit || !expanded ? '' :
            <DeleteConfirm
                callback_yes={e => this.confirm_delete_item()}
                callback_no={e => this.cancel_delete_item()}/>;

        const publish_button = in_title_edit || in_delete_confirm || !expanded ? '' :
            <SmallGenericButton
                onMouseOver={e => this.hover_edit(e, true)}
                onMouseOut={e => this.hover_edit(e, false)}
                onClick={e => this.publish_work_item()}>
                publish
            </SmallGenericButton>

        return <IndentedContentWrapper>
            {workset_item_title_input}{workset_item_value}
            {edit_link}{ok_button}{cancel_button}
            {publish_button}
            {delete_item}{delete_confirm}
            {workset_item_detail}
        </IndentedContentWrapper>
    }
}

export default WorksetItem;

